/**
 * 设备报警配置 - 筛选表单
 */
import React, { useState, useEffect, useMemo } from 'react';
import { Form, Button, Select, Cascader } from 'antd';
import { jtDeviceAlarmTypeData } from '@/constants/jtDeviceAlarm';
import styles from '@/styles/pageContent.module.scss';

interface SearchFormProps {
    onSearch: (values: any) => void;
    onOpenDetail: (record: any) => void;
    onCreate: () => void;
}

const SearchForm: React.FC<SearchFormProps> = ({ onSearch, onOpenDetail, onCreate }) => {
    const [form] = Form.useForm();
    const [aggregationType, setAggregationType] = useState<string>();
    const [alarmTypes, setAlarmTypes] = useState<any[]>([]);

    // 生成默认全选的报警类型
    const defaultAlarmTypes = useMemo(() => {
        return jtDeviceAlarmTypeData
            .map((item: any) =>
                item.children.map((item1: any) => [item.value, item1.value])
            )
            .flat(1);
    }, []);

    // 初始化时设置默认报警类型
    useEffect(() => {
        setAlarmTypes(defaultAlarmTypes);
    }, [defaultAlarmTypes]);

    // 搜索
    const handleSearch = () => {
        form.validateFields().then((values) => {
            onSearch({ ...values, aggregationType });
        });
    };

    return (
        <div style={{ marginBottom: 16 }}>
            <Form form={form} layout="inline" className={styles.searchBox}>
                <Form.Item name="aggregationType" label="聚合方式">
                    <Select
                        placeholder="请选择聚合方式"
                        style={{ width: 200 }}
                        onChange={setAggregationType}
                        options={[
                            { label: '按照车辆聚合', value: 'plate' },
                            { label: '按照报警类型聚合', value: 'alarmType' },
                        ]}
                    />
                </Form.Item>
                <Form.Item name="alarmTypes" label="报警类型" initialValue={defaultAlarmTypes}>
                    <Cascader
                        multiple
                        options={jtDeviceAlarmTypeData}
                        maxTagCount="responsive"
                        allowClear
                        showCheckedStrategy={Cascader.SHOW_CHILD}
                        showSearch
                        style={{ width: 700 }}
                        placeholder="请选择报警类型"
                        onChange={(value) => setAlarmTypes(value)}
                    />
                </Form.Item>
                {/* 查询表单项预留位置 */}
                <Form.Item>
                    <Button
                        type="primary"
                        onClick={handleSearch}
                        disabled={!aggregationType || !alarmTypes || alarmTypes.length === 0}
                    >
                        查询
                    </Button>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" onClick={onCreate}>
                        创建预警提醒配置
                    </Button>
                </Form.Item>
            </Form>
        </div>

    );
};

export default SearchForm;
